import styles from "./bottomFixedModal.module.scss";
import React from "react";
import { ButtonBox } from "../../button/Button";
import Icon from "../../icons/Icon";
import XG900 from "../../icons/24/XG900";

interface Props {
  isTransition?: boolean;
  isShow: boolean;
  hideModal: () => void;
  title?: string | React.ReactNode;
  hasCloseButton?: boolean;
  children: React.ReactNode;
  className?: string;
  fullHeight?: boolean;
  overlayBgColor?: string;
  modalStyle?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
  closeButtonType?: "icon" | "text";
  closeButtonPosition?: "top" | "title";
  hasHeightLimit?: boolean;
  hasInnerScroll?: boolean;
  zIndex?: number;
}
const BottomFixedModal = ({
  isTransition = false,
  isShow,
  hideModal,
  title,
  children,
  hasCloseButton = false,
  closeButtonType = "icon",
  className,
  overlayBgColor,
  modalStyle = {},
  contentStyle = {},
  closeButtonPosition = "top",
  fullHeight = false,
  hasHeightLimit = false,
  hasInnerScroll = false,
  zIndex,
}: Props) => {
  // className.includes("bottom-fixed-modal-wrap") 으로 클래스를 갖고 있으면 기본 클래스가 붙도록 작업함
  // 기존 웹뷰 프로젝트에서 해당 클래스 기준으로 스타일 수정한게 많아서 처리용
  // 가능하면 예외적인 스타일 수정보다는 해당 컴포넌트의 module.scss 통해서 공통으로 사용할 수 있는 스타일을 적용하는게 좋을듯함
  const prevClassCheck = className ? className?.includes("bottom-fixed-modal-wrap") : false;

  // 닫기버튼
  const CloseButton = () => {
    return (
      <div
        className={`${styles["modal-close-button-wrap"]} ${prevClassCheck ? "modal-close-button-wrap" : ""}`}
      >
        <ButtonBox
          type="icon"
          theme="close"
          transparent="all"
          onClick={hideModal}
          className={`${prevClassCheck ? "btn" : ""}`}
        >
          {closeButtonType === "icon" ? <Icon IconComponent={<XG900 />} size={24} /> : "닫기"}
        </ButtonBox>
      </div>
    );
  };

  return (
    <div
      className={`${styles["bottom-fixed-modal-wrap"]} ${isShow ? styles["show"] : ""} ${className} ${fullHeight ? styles["full-height"] : ""}`}
      style={zIndex ? { zIndex: zIndex, position: "relative" } : {}}
    >
      <div
        className={`${styles["overlay"]} ${prevClassCheck ? "overlay" : ""}`}
        onClick={(e) => {
          hideModal();
        }}
        style={{ background: `${overlayBgColor ? overlayBgColor : ""}` }}
      ></div>
      <div
        className={`
          ${prevClassCheck ? "bottom-fixed-modal" : ""} 
          ${styles["bottom-fixed-modal"]} 
          ${isTransition ? styles["has-transition"] : ""} 
          ${isShow ? styles["do-transtion"] : ""} 
          ${hasHeightLimit ? styles["has-height-limit"] : ""}
          ${hasInnerScroll ? styles["has-inner-scroll"] : ""}`
        }
        style={modalStyle}
      >
        {hasCloseButton && closeButtonPosition === "top" && <CloseButton />}
        <div
          className={`${styles["modal-title-wrap"]} ${prevClassCheck ? "modal-title-wrap" : ""}`}
        >
          {title && (
            <h2
              className={`${styles["modal-title"]} ${prevClassCheck ? "modal-title" : ""}`}
              style={hasCloseButton ? { paddingRight: 50 } : {}}
            >
              {title}
            </h2>
          )}
          {hasCloseButton && closeButtonPosition === "title" && <CloseButton />}
        </div>
        <div
          className={`${styles["modal-content"]} ${prevClassCheck ? "modal-content" : ""}`}
          style={contentStyle}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default BottomFixedModal;
